/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {TableHeaderEntryModel} from '../../shared/table/models/table-header-entry.model';
import {PartNumberChangesColumnEnum} from '../models/part-number-changes-column.enum';
import * as TablePartNumberChangesPipes from './data-pipes/part-number-changes-main-page-data-pipes';


const pncMainPageHeadersConfiguration: {
    supplyingPackingPlant: TableHeaderEntryModel<PartNumberChangesColumnEnum>;
    type: TableHeaderEntryModel<PartNumberChangesColumnEnum>;
    number: TableHeaderEntryModel<PartNumberChangesColumnEnum>;
    createdBy: TableHeaderEntryModel<PartNumberChangesColumnEnum>;
    creationDateTime: TableHeaderEntryModel<PartNumberChangesColumnEnum>;
    partner: TableHeaderEntryModel<PartNumberChangesColumnEnum>;
    updatedBy: TableHeaderEntryModel<PartNumberChangesColumnEnum>;
    changedOn: TableHeaderEntryModel<PartNumberChangesColumnEnum>;
    oldMaterialNumber: TableHeaderEntryModel<PartNumberChangesColumnEnum>;
    status: TableHeaderEntryModel<PartNumberChangesColumnEnum>;
    technicianGroup: TableHeaderEntryModel<PartNumberChangesColumnEnum>;
    newPartNumber: TableHeaderEntryModel<PartNumberChangesColumnEnum>;
    done: TableHeaderEntryModel<PartNumberChangesColumnEnum>;
} = {
    supplyingPackingPlant: {
        code: PartNumberChangesColumnEnum.SUPPLYING_PACKING_PLANT,
        name: 'Supplying Packing Plant',
        sortable: true,
        widthWeight: 9,
        dataPipe: TablePartNumberChangesPipes.supplyingPackingPlantPipe,
        hasCopyPaste: true
    },
    type: {
        code: PartNumberChangesColumnEnum.TYPE,
        name: 'PNC Type',
        sortable: true,
        widthWeight: 7,
        hasCopyPaste: true
    },
    number: {
        code: PartNumberChangesColumnEnum.NUMBER,
        name: 'PNC No.',
        sortable: true,
        widthWeight: 7,
        hasCopyPaste: true
    },
    createdBy: {
        code: PartNumberChangesColumnEnum.CREATED_BY,
        name: 'Created by',
        sortable: true,
        widthWeight: 7,
        dataPipe: TablePartNumberChangesPipes.userPipe,
        hasCopyPaste: true
    },
    creationDateTime: {
        code: PartNumberChangesColumnEnum.CREATION_DATETIME,
        name: 'Creation date',
        sortable: true,
        widthWeight: 7,
        hasCopyPaste: true
    },
    partner: {
        code: PartNumberChangesColumnEnum.PARTNER,
        name: 'Partner',
        sortable: true,
        widthWeight: 7,
        dataPipe: TablePartNumberChangesPipes.partnerPipe,
        hasCopyPaste: true
    },
    updatedBy: {
        code: PartNumberChangesColumnEnum.UPDATED_BY,
        name: 'Updated by',
        sortable: true,
        widthWeight: 7,
        dataPipe: TablePartNumberChangesPipes.userPipe,
        hasCopyPaste: true
    },
    changedOn: {
        code: PartNumberChangesColumnEnum.CHANGED_ON,
        name: 'Last modify',
        sortable: true,
        widthWeight: 7,
        hasCopyPaste: true
    },
    oldMaterialNumber: {
        code: PartNumberChangesColumnEnum.OLD_MATERIAL_NUMBER,
        name: 'Old part No.',
        sortable: true,
        widthWeight: 9,
        dataPipe: TablePartNumberChangesPipes.partNumberPipe,
        hasCopyPaste: true
    },
    status: {
        code: PartNumberChangesColumnEnum.STATUS,
        name: 'Status',
        sortable: true,
        widthWeight: 7,
        hasDot: true,
        dataPipe: TablePartNumberChangesPipes.statusPipe,
        hasCopyPaste: true
    },
    technicianGroup: {
        code: PartNumberChangesColumnEnum.TECHNICIAN_GROUP,
        name: 'Technicians group',
        sortable: true,
        widthWeight: 7,
        dataPipe: TablePartNumberChangesPipes.techniciansGroupPipe,
        hasCopyPaste: true
    },
    newPartNumber: {
        code: PartNumberChangesColumnEnum.NEW_PART_NUMBER,
        name: 'New part No.',
        sortable: true,
        widthWeight: 12,
        dataPipe: TablePartNumberChangesPipes.partNumberPipe,
        hasCopyPaste: true
    },
    done: {
        code: PartNumberChangesColumnEnum.DONE,
        name: 'Done/Undone',
        sortable: true,
        widthWeight: 7,
        dataPipe: TablePartNumberChangesPipes.doneUndonePipe
    }
};

export default pncMainPageHeadersConfiguration;
